import { createFileRoute } from '@tanstack/react-router';
import { TopLevelPage } from '@/components/top-level-page';
import { MembersPage } from '@/features/members/pages/members-page';

export const Route = createFileRoute('/_app/staff')({
  component: () => (
    <TopLevelPage path="/staff">
      <MembersPage />
    </TopLevelPage>
  ),
});
